import { Component } from '@angular/core';

@Component({
  selector: 'app-gear-small',
  templateUrl: './gear-small.component.html',
  styleUrls: ['./gear-small.component.scss']
})
export class GearSmallComponent {

}
